import React from 'react';
import { Bell } from 'lucide-react';

const Header = ({ title, subtitle, action }) => {
  return (
    <header className="glass-header sticky top-0 z-20 px-4 sm:px-6 lg:px-10 py-4 lg:py-5">
      <div className="flex items-center justify-between gap-4 max-w-[1500px] mx-auto">
        <div className="min-w-0">
          <h1 className="font-heading text-xl sm:text-2xl font-extrabold text-slate-900 truncate tracking-tight">{title}</h1>
          {subtitle && (
            <p className="text-xs sm:text-sm text-slate-500 mt-0.5 truncate">{subtitle}</p>
          )}
        </div>
        <div className="flex items-center gap-2">
          {action}
          <button
            data-testid="notifications-btn"
            className="relative p-2 text-slate-500 hover:text-slate-900 hover:bg-slate-100 rounded-lg transition-colors"
            aria-label="Notifications"
          >
            <Bell className="w-4 h-4" />
            <span className="absolute top-1 right-1 w-2 h-2 bg-gradient-to-r from-violet-600 to-blue-600 rounded-full" />
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
